import { render } from "./shop.vue?vue&type=template&id=59d57b1f&scoped=true"
import script from "./shop.vue?vue&type=script&lang=js"
export * from "./shop.vue?vue&type=script&lang=js"

import "./shop.vue?vue&type=style&index=0&id=59d57b1f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\28950\\source\\repos\\xtz\\hql\\bm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59d57b1f"]])

export default __exports__